import React from 'react';
import ReactDOM from 'react-dom';
import './Popup.scss';
import CloseIconSrc from '../../assets/icons/icon-close.svg';
import LikeIconPath from '../../assets/icons/icon-like.svg';
import DislikeIconPath from '../../assets/icons/icon-dislike.svg';

const Popup = ({ isOpen, onClose, children, status }) => {
 
  if (!isOpen) return null;

  let iconSrc, iconAlt;
  if (status === 'like') {
    iconSrc = LikeIconPath;
    iconAlt = 'Like';
  } else if (status === 'dislike') {
    iconSrc = DislikeIconPath;
    iconAlt = 'Dislike';
  }

  return ReactDOM.createPortal(
    (
      <div className="popup">
        <div className="popup__overlay" onClick={onClose}>
          <div className="popup__content" onClick={(e) => e.stopPropagation()}>
            <button className="popup__content--close-btn" onClick={onClose} aria-label="Close">
              <img src={CloseIconSrc} alt="Close" />
            </button>
            {iconSrc && <img src={iconSrc} alt={iconAlt} className="popup__icon" />}
            {children}
          </div>
        </div>
      </div>
    ),
    document.body 
  );
};


export default Popup;


